import type { TFunction } from 'i18next';

import { type ILinkProduct, LevelType } from '../../apis/ilink.type';
import { type BreadcrumbLevel } from '../../store/catalogSlice';
import { RoutesPath } from '../../core/routes';

export const getBreadcrumbPath = (breadcrumbLevel: BreadcrumbLevel, breadcrumbSearch: BreadcrumbLevel[]): string => {
  const processId = breadcrumbSearch.find(b => b.level === LevelType.categories)?.id;
  const categoryId = breadcrumbSearch.find(b => b.level === LevelType.products)?.id;
  switch (breadcrumbLevel.level) {
    case LevelType.processes:
      return 'processes';
    case LevelType.categories:
      return `processes/${processId}/categories`;
    case LevelType.products:
      return `processes/${processId}/categories/${categoryId}/products`;
    default:
      return '';
  }
};

export const getBreadcrumbFromSportsCatalog = (breadcrumbLevel: BreadcrumbLevel, breadcrumbSearch: BreadcrumbLevel[]): string => {
  const processId = breadcrumbSearch.find(b => b.level === LevelType.natures)?.id;
  const natureId = breadcrumbSearch.find(b => b.level === LevelType.products)?.id;

  if (breadcrumbLevel.level === LevelType.processes) return 'processes';
  if (breadcrumbLevel.level === LevelType.natures) return `processes/${processId}/product-nature-groups`;
  if (breadcrumbLevel.level === LevelType.products) return `processes/${processId}/product-nature-groups/${natureId}/products`;

  return '';
};

export const getCatalogPathByBreadCrumb = (breadcrumb: BreadcrumbLevel[]) => {
  const processId = breadcrumb.find(({ level }) => level === 'categories')?.id;
  const basePath = RoutesPath.catalogProcessesPage;

  if (!processId) return basePath;
  return `${basePath}/${processId}/categories`;
};

export const getBreadCrumbLevels = (currentProduct: ILinkProduct, isCatalogSportsActive: boolean, t: TFunction): BreadcrumbLevel[] => {
  if (isCatalogSportsActive) {
    return [
      { level: LevelType.processes, label: t('catalog.breadcrumb.search.root') },
      ...(currentProduct.process ? [{ level: LevelType.natures, label: currentProduct.process.label, id: currentProduct.process.id }] : []),
      { level: LevelType.products, label: currentProduct.groupNatureLevelTwo?.label, id: currentProduct.groupNatureLevelTwo?.id },
      { level: LevelType.product, label: t('catalog.breadcrumb.search.product') },
    ];
  }

  return [
    { level: LevelType.processes, label: t('catalog.breadcrumb.search.root') },
    ...(currentProduct.process ? [{ level: LevelType.categories, label: currentProduct.process.label, id: currentProduct.process.id }] : []),
    ...(currentProduct.category ? [{ level: LevelType.products, label: currentProduct.category.label, id: currentProduct.category.id }] : []),
    { level: LevelType.product, label: t('catalog.breadcrumb.search.product') },
  ];
};
